const API_BASE = process.env.REACT_APP_API_BASE || "/api";

const toNetworkError = (error, path) => {
  const url = `${API_BASE}${path}`;
  const originalMessage =
    error instanceof Error && error.message ? error.message : String(error || "");
  const suffix = originalMessage ? ` (Original error: ${originalMessage})` : "";
  return new Error(`Failed to reach API: ${url}.${suffix}`);
};

const doFetch = async (path, options = {}) => {
  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, options);
  } catch (error) {
    throw toNetworkError(error, path);
  }

  if (!res.ok) {
    const text = await res.text();
    let message = text || `Request failed: ${res.status}`;
    if (res.status === 404 && /Cannot\s+POST\s+\/api\/coach\//i.test(text)) {
      message =
        "Study Coach API endpoint was not found. Restart the backend on this branch (run `npm run dev` or restart `npm run server`).";
    }
    throw new Error(message);
  }
  if (res.status === 204) return null;
  return res.json();
};

export const sendCoachMessage = async (payload) =>
  doFetch("/coach/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
  });

export const extractStudyMaterial = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return doFetch("/coach/materials/extract", {
    method: "POST",
    body: formData,
  });
};
